import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon, SmartphoneIcon, CheckIcon, ShieldCheckIcon, DownloadIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const packageItems = [{
  item: 'Ebook Principal "RE-NAISSANCE" (60 pages)',
  value: '97$'
}, {
  item: 'Bonus #1 : Guide du Style Post-Divorce',
  value: '47$'
}, {
  item: "Bonus #2 : L'Agenda de la Liberté",
  value: '27$'
}, {
  item: 'Bonus #3 : 50 Activités de Renaissance à 0$',
  value: '37$'
}, {
  item: "Bonus #4 : Le Manifeste de l'Estime de Soi",
  value: '27$'
}];
export function ClosingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 14.97;
  const bumpPrice = 9.97;
  const total = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  return <section className="bg-gradient-to-b from-cream to-burgundy py-10 px-6 md:py-16" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal text-center mb-8" data-id="element-15">
            Ce soir, tu as deux chemins devant toi.
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-16">
            <div className="bg-gray-100 bg-opacity-50 p-6 rounded-lg" data-id="element-17">
              <h3 className="font-playfair text-2xl text-gray-600 mb-4" data-id="element-18">
                Chemin 1 :
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-19">
                <p data-id="element-20">
                  Tu fermes cette page. Tu retournes sur Instagram regarder des
                  gens qui semblent heureux. Tu te dis que "ça ira mieux avec le
                  temps".
                </p>
                <p data-id="element-21">
                  Et dans 6 mois, tu te retrouveras exactement au même endroit.
                  Même fatigue. Même vide. Même question dans le miroir.
                </p>
                <p className="italic" data-id="element-22">
                  "Mais où est-elle passée, la femme que j'étais ?"
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border-2 border-gold shadow-lg" data-id="element-23">
              <h3 className="font-playfair text-2xl text-burgundy mb-4" data-id="element-24">
                Chemin 2 :
              </h3>
              <div className="space-y-3 text-charcoal" data-id="element-25">
                <p data-id="element-26">
                  Tu cliques sur le bouton ci-dessous. Dans 47 secondes, tu as
                  accès à l'intégralité du Pack RE-NAISSANCE sur ton téléphone.
                </p>
                <p data-id="element-27">
                  Ce soir, tu lis la première lettre. Demain matin, tu fais ton
                  premier exercice de 5 minutes.
                </p>
                <p data-id="element-28">Et dans 30 jours ?</p>
                <p className="font-semibold text-burgundy" data-id="element-29">
                  Tu es la femme que tu regardes dans le miroir avec fierté.
                </p>
                <p data-id="element-30">Pas parce que tout est parfait.</p>
                <p className="text-lg font-semibold" data-id="element-31">
                  Mais parce que tu as choisi de ne plus attendre la permission
                  d'exister.
                </p>
              </div>
            </div>
          </div>

          <div id="pricing" className="text-center mb-8" data-id="element-32">
            <p className="text-xl text-white mb-6" data-id="element-33">
              ✨ UN SEUL CLIC SÉPARE LA FEMME QUE TU ES DE LA FEMME QUE TU
              DEVIENS.
            </p>

            {/* Order Bump #1 */}
            <motion.div animate={{
            boxShadow: ['0 0 0px rgba(226,114,91,0)', '0 0 14px rgba(226,114,91,0.4)', '0 0 0px rgba(226,114,91,0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="bg-[#FFFBF5] border-2 border-dashed border-[#E2725B] rounded-lg overflow-hidden mb-4 text-left max-w-xl mx-auto" data-id="element-34">
              <div className="bg-[#E2725B] px-4 py-1.5" data-id="element-35">
                <p className="text-white text-xs font-bold uppercase tracking-wider text-center" data-id="element-36">
                  Hautement recommandé
                </p>
              </div>
              <div className="p-5" data-id="element-37">
                <div className="flex gap-4 items-start mb-3" data-id="element-38">
                  <label className="flex items-center gap-3 cursor-pointer flex-1" data-id="element-39">
                    <input type="checkbox" checked={bump1} onChange={e => setBump1(e.target.checked)} className="w-5 h-5 accent-burgundy flex-shrink-0 mt-1" data-id="element-40" />
                    <div data-id="element-41">
                      <h4 className="font-playfair font-bold text-burgundy text-lg leading-tight" data-id="element-42">
                        L'Art d'Être Seule
                      </h4>
                      <p className="text-sm font-bold text-[#E2725B] mt-1" data-id="element-43">
                        Ajouter pour 9.97$
                      </p>
                    </div>
                  </label>
                  <img src="https://cdn.magicpatterns.com/uploads/jQEYbyZ152hfMqMFGXzyUs/ORDER_BUMP_1.png" alt="L'Art d'Être Seule" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-44" />
                </div>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-45">
                  Ne subis plus jamais le silence pesant de la maison vide.
                  Découvre comment transformer ces moments redoutés en ton
                  propre sanctuaire de force. Ce guide t'enseigne l'art de
                  "s'auto-suffire" pour ne plus jamais attendre que le téléphone
                  sonne pour te sentir vivante.
                </p>
              </div>
            </motion.div>

            {/* Order Bump #2 */}
            <motion.div animate={{
            boxShadow: ['0 0 0px rgba(226,114,91,0)', '0 0 14px rgba(226,114,91,0.4)', '0 0 0px rgba(226,114,91,0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1.25
          }} className="bg-[#FFFBF5] border-2 border-dashed border-[#E2725B] rounded-lg overflow-hidden mb-6 text-left max-w-xl mx-auto" data-id="element-46">
              <div className="bg-[#E2725B] px-4 py-1.5" data-id="element-47">
                <p className="text-white text-xs font-bold uppercase tracking-wider text-center" data-id="element-48">
                  Hautement recommandé
                </p>
              </div>
              <div className="p-5" data-id="element-49">
                <div className="flex gap-4 items-start mb-3" data-id="element-50">
                  <label className="flex items-center gap-3 cursor-pointer flex-1" data-id="element-51">
                    <input type="checkbox" checked={bump2} onChange={e => setBump2(e.target.checked)} className="w-5 h-5 accent-burgundy flex-shrink-0 mt-1" data-id="element-52" />
                    <div data-id="element-53">
                      <h4 className="font-playfair font-bold text-burgundy text-lg leading-tight" data-id="element-54">
                        Le Protocole "Oublier l'Ex"
                      </h4>
                      <p className="text-sm font-bold text-[#E2725B] mt-1" data-id="element-55">
                        Ajouter pour 9.97$
                      </p>
                    </div>
                  </label>
                  <img src="https://cdn.magicpatterns.com/uploads/qUoCX3vzeRWfZExAtApLkE/ORDER_BUMP_2.png" alt="Le Protocole Oublier l'Ex" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-56" />
                </div>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-57">
                  Arrête de rejouer le film du divorce en boucle dans ta tête.
                  Ce protocole d'urgence est conçu pour couper les ponts
                  émotionnels et stopper les ruminations liées à ton
                  ex-conjoint. Reprends ton espace mental pour te concentrer sur
                  la seule personne qui compte : TOI.
                </p>
              </div>
            </motion.div>

            {/* Order Summary */}
            <div className="bg-white rounded-lg p-6 shadow-xl max-w-xl mx-auto mb-6 text-left" data-id="element-58">
              <h3 className="font-playfair text-xl text-burgundy text-center mb-4" data-id="element-59">
                📋 Résumé de ma Commande
              </h3>

              <div className="space-y-3 mb-4" data-id="element-60">
                <div className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-61">
                  <div data-id="element-62">
                    <p className="font-semibold text-charcoal" data-id="element-63">
                      RE-NAISSANCE + 4 Bonus
                    </p>
                    <p className="text-xs text-gray-400 line-through" data-id="element-64">
                      97$ — Prix de lancement spécial
                    </p>
                  </div>
                  <span className="font-bold text-charcoal" data-id="element-65">14.97$</span>
                </div>

                {bump1 && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-66">
                    <p className="font-semibold text-charcoal" data-id="element-67">
                      L'Art d'Être Seule
                    </p>
                    <span className="font-bold text-charcoal" data-id="element-68">9.97$</span>
                  </motion.div>}

                {bump2 && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-69">
                    <p className="font-semibold text-charcoal" data-id="element-70">
                      Le Protocole "Oublier l'Ex"
                    </p>
                    <span className="font-bold text-charcoal" data-id="element-71">9.97$</span>
                  </motion.div>}
              </div>

              <div className="flex justify-between items-center pt-2 border-t-2 border-[#E2725B] mb-6" data-id="element-72">
                <p className="text-lg font-bold text-[#E2725B]" data-id="element-73">
                  TOTAL À PAYER
                </p>
                <p className="text-2xl font-bold text-[#E2725B]" data-id="element-74">
                  {total.toFixed(2)}$
                </p>
              </div>

              {/* Reassurance */}
              <div className="space-y-2.5 mb-6" data-id="element-75">
                <div className="flex items-start gap-2.5" data-id="element-76">
                  <DownloadIcon size={18} className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-77" />
                  <p className="text-sm text-gray-600" data-id="element-78">
                    Téléchargement immédiat — Commence maintenant — tout ce dont
                    tu as besoin est ton téléphone.
                  </p>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-79">
                  <ShieldCheckIcon size={18} className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-80" />
                  <p className="text-sm text-gray-600" data-id="element-81">
                    Garantie "Souveraine" de 30 jours.
                  </p>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-82">
                  <LockIcon size={18} className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-83" />
                  <p className="text-sm text-gray-600" data-id="element-84">
                    Paiement 100% Sécurisé & Crypté.
                  </p>
                </div>
              </div>

              {/* Main CTA */}
              <motion.button animate={{
              boxShadow: ['0 0 0px rgba(226,114,91,0)', '0 0 20px rgba(226,114,91,0.5)', '0 0 0px rgba(226,114,91,0)']
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="w-full bg-[#E2725B] text-white py-4 rounded-lg text-lg font-bold hover:bg-[#d4654f] transition-colors" onClick={() => {
              let cartUrl = 'https://redevenirmoi.com/cart/53433582256496:1';
              if (bump1 && bump2) {
                cartUrl = 'https://redevenirmoi.com/cart/53481674637680:1';
              } else if (bump1) {
                cartUrl = 'https://redevenirmoi.com/cart/53481685680496:1';
              } else if (bump2) {
                cartUrl = 'https://redevenirmoi.com/cart/53481679716720:1';
              }
              trackAddToCart({
                content_name: 'RE-NAISSANCE Pack',
                content_type: 'product',
                value: total,
                currency: 'CAD'
              });
              window.open(cartUrl, '_blank');
            }} data-id="element-85">
                OUI, JE VEUX MA RENAISSANCE MAINTENANT
              </motion.button>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-white mb-8" data-id="element-86">
              <div className="flex items-center gap-2" data-id="element-87">
                <SmartphoneIcon size={20} data-id="element-88" />
                <span data-id="element-89">Compatible Mobile, Tablette & Ordinateur</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}